import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.93.481a1 1 0 0 1 1.415 0L12 2.137 13.655.48a1 1 0 1 1 1.415 1.415L13.414 3.55l1.656 1.655a1 1 0 0 1-1.415 1.415L12 4.965l-1.655 1.656A1 1 0 1 1 8.93 5.206l1.656-1.655L8.93 1.896a1 1 0 0 1 0-1.415M7.75 9.083a1 1 0 0 0-1 1v12.82a1 1 0 1 0 2 0v-11.82h6.5v11.82a1 1 0 1 0 2 0v-12.82a1 1 0 0 0-1-1zm10.75 3.895a1 1 0 0 1 1-1h3.266a1 1 0 0 1 1 1v9.925a1 1 0 1 1-2 0v-8.925H19.5a1 1 0 0 1-1-1m-14-1a1 1 0 0 1 0 2H2.234v8.925a1 1 0 1 1-2 0v-9.925a1 1 0 0 1 1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const TableColRemove = { render };
export {
  TableColRemove as default,
  render
};
//# sourceMappingURL=TableColRemove.svg.js.map
